"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles = __importStar(require("./Footer.module.css"));
var Footer = (function (_super) {
    __extends(Footer, _super);
    function Footer(props) {
        return _super.call(this, props) || this;
    }
    Footer.prototype.render = function () {
        var _a = this.props.info, left = _a.left, right = _a.right;
        return (react_1.default.createElement("footer", { className: styles.footer },
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "col-xs-12 col-md-6" },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("p", null, left.content))),
                react_1.default.createElement("div", { className: "col-xs-12 col-md-6" },
                    react_1.default.createElement("div", { className: styles.footerRight },
                        react_1.default.createElement("p", null,
                            react_1.default.createElement("b", { className: styles.footerRightNo }, right)))))));
    };
    return Footer;
}(react_1.Component));
exports.default = Footer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRm9vdGVyLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvZm9ybXMvaW50ZWxsaXRlYy9Db21tb25TZWN0aW9ucy9Gb290ZXIvRm9vdGVyLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsNkNBQXNDO0FBQ3RDLDBEQUE2QztBQU03QztJQUFvQywwQkFBZ0I7SUFDaEQsZ0JBQVksS0FBSztlQUNiLGtCQUFNLEtBQUssQ0FBQztJQUNoQixDQUFDO0lBRUQsdUJBQU0sR0FBTjtRQUNVLElBQUEsb0JBQStCLEVBQTlCLGNBQUksRUFBRSxnQkFBd0IsQ0FBQTtRQUNyQyxPQUFPLENBQ0gsMENBQVEsU0FBUyxFQUFFLE1BQU0sQ0FBQyxNQUFNO1lBQzVCLHVDQUFLLFNBQVMsRUFBQyxLQUFLO2dCQUNoQix1Q0FBSyxTQUFTLEVBQUMsb0JBQW9CO29CQUMvQjt3QkFDSSx5Q0FBSSxJQUFJLENBQUMsT0FBTyxDQUFLLENBQ25CLENBQ0o7Z0JBQ04sdUNBQUssU0FBUyxFQUFDLG9CQUFvQjtvQkFDL0IsdUNBQUssU0FBUyxFQUFFLE1BQU0sQ0FBQyxXQUFXO3dCQUM5Qjs0QkFDSSxxQ0FBRyxTQUFTLEVBQUUsTUFBTSxDQUFDLGFBQWEsSUFBRyxLQUFLLENBQUssQ0FDL0MsQ0FDRixDQUNKLENBQ0osQ0FDRCxDQUNaLENBQUE7SUFDTCxDQUFDO0lBQ0wsYUFBQztBQUFELENBQUMsQUExQkQsQ0FBb0MsaUJBQVMsR0EwQjVDIn0=